module.exports = __webpack_public_path__ + "media/images/icon-calendar-86bb7878.svg";